<template>
    <div>
        <v-container style="max-width: 1500px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" style="color: #fff" dark>
                    Sala
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <v-row style="padding: 1rem;">
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchSubactividad" label="Paciente"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field max-width="200" class="mx-3" v-model="searchDNI" label="DNI"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field max-width="200" class="mx-3" v-model="searchAutogenerado" label="Autogenerado"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="date" label="Periodo" append-icon="mdi-calendar" outlined dense
                                    readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" type="month" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal = false">
                                    Cancel
                                </v-btn>
                                <v-btn text color="primary" @click="saveDate">
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" lg="2" md="2">
                        <v-select max-width="200" class="mx-3" v-model="searchSala" label="Sala"
                            append-icon="mdi-magnify" outlined dense multiple item-text="label" item-value="value"
                            :items="salasItems"></v-select>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" style=" margin:0 auto;padding: 1.5rem;">
                <v-row style="padding: 0 1rem ;">
                    <v-menu offset-y transition="scale-transition" :close-on-content-click="false">
                        <template v-slot:activator="{ on: menu, attrs }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on: tooltip }">
                                    <v-btn elevation="2" v-bind="attrs" v-on="{ ...tooltip, ...menu }"
                                        style="margin:1rem 0 2rem 0;">
                                        <v-icon class="custom-icon">
                                            mdi-format-list-bulleted-square
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar columnas</span>
                            </v-tooltip>
                        </template>

                        <v-list style="max-height:30rem;height: 100%;">
                            <v-list-item style="max-width:50rem;height: 100%;     background: white;">
                                <v-list-item-title>
                                    <v-list>
                                        <v-list-item ripple @mousedown.prevent @click="toggle">
                                            <v-list-item-action>
                                                <v-icon :color="selectedColumns.length > 0 ? 'indigo darken-4' : ''">
                                                    {{ icon }}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    Seleccionar todo
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider class="mt-2"></v-divider>

                                        <!-- Mostrar columnas con checkboxes -->
                                        <v-list-item v-for="header in headers" :key="header.value"
                                            @click="toggleColumn(header.value)">
                                            <v-list-item-action>
                                                <v-checkbox v-model="selectedColumns"
                                                    :value="header.value"></v-checkbox>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ header.text }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-col cols="6" sm="3" md="3" style="padding-top:0 !important;">
                        <v-btn color="blue" dark class="mb-2" @click="statusEdit = !statusEdit" v-if="statusEdit"
                            style="margin: 1rem 1rem;">
                            Editar
                        </v-btn>
                        <v-btn color="blue" v-if="!statusEdit" dark class="mb-2" @click="save"
                            style="margin: 1rem 1rem;">
                            Guardar
                        </v-btn>
                    </v-col>
                </v-row>
                <div>
                    <v-data-table :headers="filteredHeaders" :items="filteredData" :loading="isLoading" dense
                        loading-text="Cargando... Por favor espere" style="margin: 0 auto;">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip bottom color="teal">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark @click="dialogHistograma = true"
                                        color="teal" v-bind="attrs" v-on="on">
                                        <v-icon class="custom-icon" dark>
                                            mdi-format-list-bulleted-square
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver diagrama</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.sala`]="{ item }">
                            <v-select v-model="item.sala" hide-details dense style="text-align: center;"
                                :items="['', '1', '2', '3', '4', '5']" :disabled="statusEdit"
                                @input="onInputChange(item)"></v-select>
                        </template>
                        <template v-slot:[`item.sala_copia`]="{ item }">
                            <v-select v-model="item.sala_copia" hide-details dense style="text-align: center;"
                                :items="['', '1', '2', '3', '4', '5']" :disabled="statusEdit"
                                @input="onInputChange(item)"></v-select>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<style scoped>
.system-bar-title {
    padding: 1.2rem 1.4rem !important;
}

.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}

.custom-btn {
    width: 32px !important;
    height: 32px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";

export default {
    data() {
        return {
            salasItems: [
                { label: "Clínicas", value: "0" },
                { label: "S1 CNSR", value: "1" },
                { label: "S2 CNSR", value: "2" },
                { label: "S3 CNSR", value: "3" },
                { label: "S4 CNSR", value: "4" },
                { label: "S5 DP", value: "5" }
            ],
            statusEdit: true,
            dialogHistograma: false,
            date: new Date().toISOString().slice(0, 7),
            modal: false,
            searchSubactividad: null,
            searchDNI: null,
            searchAutogenerado: null,
            dialogImport: false,
            dialogLoader: false,
            ver: false,
            searchDocumento: "",
            searchNombre: "",
            dataPaciente: [],
            dataEnvio: {
                fecha: null
            },
            searchSala: [],
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "SALA", value: "sala_copia", align: "center", width: '90px' },
                { text: "SALA", value: "sala", align: "center", width: '90px' },
                { text: "NUM DOC", value: "dni_paciente" },
                { text: "AUTOGENERADO", value: "autogenerado" },
                { text: "PACIENTE", value: "paciente" },
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            menu: false,
            idItem: null,
            selectedColumns: [
                "sala_copia", "dni_paciente", "autogenerado", "paciente"
            ],
            itemMes: null,
            itemPeriodo: null,
            dataArray: []
        };
    },
    methods: {
        guardarCambioSala(item) {
            // Asigna el valor temporal al valor real
            item.sala = item.salaTemp;
            // Puedes hacer aquí una actualización en la base de datos si es necesario
        },
        toggle() {
            if (this.selectedColumns.length === this.headers.length) {
                this.selectedColumns = [
                    "FECHA_RESULTADO", "SALA", "NUM_DOC", "AUTOGENERADO", "paciente"];
            } else {
                this.selectedColumns = this.headers.map(header => header.value);
            }
        },
        toggleColumn(value) {
            const index = this.selectedColumns.indexOf(value);
            if (index === -1) {
                this.selectedColumns.push(value);
            } else {
                this.selectedColumns.splice(index, 1);
            }
        },
        onInputChange(valor) {
            // Verifica si el array ya existe en `this.dataArray`
            const existe = this.dataArray.some(
                (arr) => JSON.stringify(arr.dni_paciente) === JSON.stringify(valor.dni_paciente)
            );

            // Si no existe, lo agrega
            if (!existe) {
                this.dataArray.push(valor);
            }
        },
        save() {
            this.dialogLoader = true;
            this.statusEdit = true;
            for (let i = 0; i < this.dataArray.length; i++) {
                const element = this.dataArray[i];
                axios
                    .post(RUTA_API + "/api/token/", {
                        username: USUARIO,
                        password: PASSWORD,
                    })
                    .then((response) => {
                        this.auth = "Bearer " + response.data.access;
                        axios
                            .post(RUTA_API + "/generar_actualizar_sala_laboratorio/", { "autogenerado": element.autogenerado, "mes": this.itemMes, "periodo": this.itemPeriodo, "sala_correcta": element.sala_copia }, {
                                headers: { Authorization: this.auth },
                            })
                            .then((res) => {
                                if (this.dataArray.length == i + 1) {
                                    this.dataArray = [];
                                    this.dialogLoader = false;
                                    this.isLoading = false;
                                    this.dataInit();
                                    this.statusEdit = true;
                                    Swal.fire({
                                        title: "¡Listo!",
                                        text: "Se guardaron los cambios.",
                                        icon: "success",
                                        confirmButtonText: "Aceptar"
                                    });
                                    return;
                                }
                            })
                            .catch((res) => {
                                console.log("Error:", res);
                            });
                    })
                    .catch((response) => {
                        response === 404
                            ? console.warn("lo sientimos no tenemos servicios")
                            : console.warn("Error:", response);
                    });

            }
            this.dialogLoader = false;
        },
        closeHistograma() {
            this.dialogHistograma = false;
        },
        saveDate() {
            // Ejecuta la lógica adicional
            this.loadPeriodo();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialog.save(this.date);
        },
        loadPeriodo() {
            let [year, month] = this.date.split('-');
            this.itemMes = month;
            this.itemPeriodo = year;
            this.dataInit();
        },
        closeDialog() {
            this.dialogImport = false;
            this.dataInit();
        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_pacientes_laboratorio/", { periodo: this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPaciente = res.data;
                            this.dataPaciente = this.dataPaciente.map(paciente => ({
                                ...paciente,
                                sala_copia: paciente.sala
                            }));

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers.filter(header => this.selectedColumns.includes(header.value));
        },
        filteredData() {
            if (!this.searchSubactividad && !this.searchDNI && !this.searchAutogenerado && this.searchSala.length == 0) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchSubactividad) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.paciente;
                    return nombreCompleto.toLowerCase().includes(this.searchSubactividad.toLowerCase());
                });
            }
            if (this.searchDNI) {
                filtered = filtered.filter((item) =>
                    item.dni_paciente
                        .toLowerCase()
                        .includes(this.searchDNI.toLowerCase())
                );
            }
            if (this.searchAutogenerado) {
                filtered = filtered.filter((item) =>
                    item.autogenerado
                        .toLowerCase()
                        .includes(this.searchAutogenerado.toLowerCase())
                );
            }
            if (this.searchSala.length !== 0) {
                filtered = filtered.filter((item) =>
                    this.searchSala.some((sala) =>
                        item.sala.toLowerCase().includes(sala.toLowerCase())
                    )
                );
            }
            return filtered;
        },
        icon() {
            if (this.likesAllFruit) return 'mdi-close-box'
            if (this.likesSomeFruit) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        likesAllFruit() {
            return this.headers.length === this.selectedColumns.length
        },
        likesSomeFruit() {
            return this.headers.length > 0 && !this.likesAllFruit
        },
    },
    created() {
        this.loadPeriodo();
    },
    components: {
    },
};
</script>